// src/store/modules/notifications.js
const initialState = () => ({
    notifications: [], // Array to hold new notifications received from the server # unread notifications # A filter of unread notifications is there to counter check if the notification is read or not
    allNotifications: [], // Array to hold all notifications, including read ones
});

const state = initialState();

const getters = {
    notifications(state) {
        return Array.from(
            new Map(
                state.notifications
                .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                .map(item => [item.id, item]) // use id as key to deduplicate
            ).values()
        ); // Return unique notifications sorted by timestamp
    },
    allNotifications(state) {
        return Array.from(
            new Map(
                state.allNotifications
                .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                .map(item => [item.id, item]) // use id as key to deduplicate
            ).values()
        ); // Return unique notifications sorted by timestamp
    },
    unreadNotifications(state) {
        return state.notifications.filter(notification => !notification.read).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    },
    unreadNotificationsCount(state) {
        return state.notifications.filter(notification => !notification.read).length;
    }
}

const mutations = {
    setNotifications(state, notifications) {
        state.notifications = notifications;
    },
    updateAllNotifications(state, notifications) {
        state.allNotifications = [...state.allNotifications, ...notifications];
    },
    resetAllNotifications(state) {
        state.allNotifications = initialState().allNotifications;
    },
    addNotification(state, payload) {
        state.notifications.unshift(payload.notification); // Add new notification to the top of the notifications list
        state.allNotifications.unshift(payload.notification); // Also add to all notifications list
    },
    markNotificationAsRead(state, notificationId) {
        const notification = state.notifications.find(n => n.id === notificationId);
        if (notification) {
            notification.read = true;
        }
        const all_notification = state.allNotifications.find(n => n.id === notificationId);
        if (all_notification) {
            all_notification.read = true;
        }
        state.notifications = state.notifications.filter(notification => !notification.read) // remove read notification from the list
    },
    markAllNotificationsAsRead(state) {
        state.notifications.forEach(notification => {
            notification.read = true;
        });
        state.notifications = initialState().notifications; // remove read notifications from the list
    }
}

const actions = {
    setNotifications({ commit }, notifications) {
        commit('setNotifications', notifications);
    },
    updateAllNotifications({ commit }, notifications) {
        commit('updateAllNotifications', notifications);
    },
    resetAllNotifications({ commit }) {
        commit('resetAllNotifications');
    },
    addNotification({ commit }, notification) {
        commit('addNotification', { notification });
    },
    markNotificationAsRead({ commit }, notificationId) {
        commit('markNotificationAsRead', notificationId);
    },
    markAllNotificationsAsRead({ commit }) {
        commit('markAllNotificationsAsRead');
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}